<template>
	<div>
		<div class="card-total" :class="{ 'card-total-reverse': cardReverse }">
			<button
				class="card-total-btn"
				type="button"
				@click="$emit('reverse-card', data)"
			>
				<app-tooltip-button
					icon="chevron_right"
				/>
			</button>
			<template v-if="cardReverse">
				<v-layout row wrap class="wrapper-info">
					<v-flex xs12>
						<v-layout row wrap align-center>
							<v-flex xs12>
								<v-layout row wrap align-center justify-space-around>
									<img :src="data.urlImage" :alt="data.name" />
									<span
										class="card-total-text"
										:style="`color:${$appColors.info}`"
									>
										{{ data.name }}
									</span>
								</v-layout>
							</v-flex>
							<v-flex xs12 pt-3 px-2>
								<v-layout row wrap align-center justify-space-around text-xs-center>
									<template
										v-for="answerDetail in data.ratePolls"
									>
										<v-flex xs6 :key="answerDetail.value">
											<span
												class="card-total-reverse-data"
												:style="`color:${$appColors.info}`"
											>
												{{ answerDetail.rate }}% {{ answerDetail.code }}
											</span>
										</v-flex>
									</template>
								</v-layout>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
			</template>
			<template v-else>
				<div class="d-flex wrapper-images">
					<img :src="data.urlImage" :alt="data.name">
					<span class="card-total-text"
						:style="`color:${$appColors.info}`"
					>
						{{ data.name }}
					</span>
					<span
						v-if="data.description"
						class="card-total-tooltip"
						:style="`color:${$appColors.secondary}`"
					>
						{{ data.description }}
					</span>
					<span
						v-else
						class="card-total-tooltip"
						:style="`color:${$appColors.secondary}`"
					>
						No se encontró información
					</span>
				</div>
				<div class="wrapper-caption">
					<div
						class="text-green"
						:style="`color:${$appColors.success};border-bottom:1px solid ${$appColors.success}`"
					>PONDERACIÓN</div>
					<div class="text-number"
						:style="`color:${$appColors.info}`"
					>{{data.value}}</div>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
import helper from '@/shared/helper';

const { getLocalData } = helper;

function created() {
	const localFactors = getLocalData('factors');
	const localFactor = localFactors ? localFactors.find(lf => lf.id === this.data.hierarchyId) :
		null;
	this.description = localFactor ? localFactor.description : '';
	this.factorsByPoll = this.poll.details.reduce((a, detail) => {
		const newItem = { ...a };
		if (!a[detail.name]) {
			newItem[detail.name] = {
				answerDetails: detail.answer.details.map(ad =>
					({ description: ad.description, id: ad.id, name: ad.name, value: ad.value })),
				answerValues: this.data.entities.map(de => de.value),
			};
		}
		return newItem;
	}, {});
}

function getText(answerName) {
	const answerNameSplit = answerName.split(' ');
	const answerNameSplitItems = answerNameSplit.reduce((acum, ans) => {
		const ansSplit = ans.split('');
		return acum.concat(ansSplit[0]);
	}, '');
	return answerNameSplitItems;
}

function getPercentage(answerValue) {
	const answerValuesFiltered = this.factorsByPoll[this.data.name].answerValues.filter(av =>
		av === answerValue);
	const percentage = Math.round((answerValuesFiltered.length / this.data.totalQuestion) * 100);
	return `${percentage}%`;
}

function data() {
	return {
		description: '',
		factorsByPoll: {},
	};
}

export default {
	name: 'card-total',
	created,
	data,
	methods: {
		getPercentage,
		getText,
	},
	props: {
		data: {
			type: Object,
			default: () => {},
		},
		cardReverse: {
			default: false,
			type: Boolean,
		},
		poll: {
			default: () => {},
			type: Object,
		},
	},
	// watch: {
	// 	'data.urlImage': dataUrlImage,
	// },
};
</script>

<style lang="scss" scoped>
	.card-total {
		background: color(white);
		border: 1px solid color(border-gray);
		border-radius: 4px;
		height: 209px;
		margin: 0 auto 30px auto;
		max-width: 186px;
		padding: 32px 28px 10px;
		position: relative;
		transition: all .5s ease-in;

		.wrapper-images {
			align-items: center;
			flex-direction: column;
			margin-bottom: 17px;
			transition: none;
		}

		.wrapper-caption {
			transition: none;
		}

		&-text {
			font-size: size(small);
			height: 36px;
			margin-top: 30px;
			text-align: center;
			text-transform: uppercase;
		}

		.text-green {
			font-size: 9px;
			padding-bottom: 5px;
		}

		.text-number {
			font-family: font(bold);
			font-size: size(xlarge);
			margin-top: 8px;
			text-align: center;
		}
	}

	.iframe-svg {
		height: 30px;
	}

	.card-total-btn {
		position: absolute;
		right: 20px;
		top: 18px;
		z-index: 2;
	}

	.card-total-tooltip {
		background-color: color(white);
		border-radius: 15px;
		bottom: 0px;
		box-shadow: 0 2px 7px 0 rgba(191, 191, 191, 0.5);
		display: none;
		font-family: font(regular);
		font-size: size(medium);
		// height: 88px;
		height: fit-content;
		height: -moz-fit-content;
		margin: auto 0px;
		padding: 22px 13px 22px 26px;
		position: absolute;
		right: -144px;
		text-align: center;
		top: 0px;
		width: 184px;
		z-index: 10;

		&:before,
		&:after {
			content: '';
		}

		&:before {
			border-bottom: 6px solid transparent;
			border-right: 12px solid white;
			border-top: 6px solid transparent;
			bottom: 0px;
			height: 6px;
			left: -11px;
			margin: auto;
			position: absolute;
			top: 0px;
			z-index: 1;
		}

		&:after {
			border-bottom: 8px solid transparent;
			border-right: 14px solid rgba(191, 191, 191, 0.5);
			border-top: 8px solid transparent;
			bottom: 0px;
			height: 7px;
			left: -13px;
			margin: auto;
			opacity: 0.4;
			position: absolute;
			top: 0px;
		}
	}

	.card-total-text:hover + .card-total-tooltip {
		display: inline-block;
	}

	.card-total-reverse {
		padding: 32px 10px 10px;
		transform: rotateY(180deg);

		.card-total-btn {
			left: 20px;
		}

		.wrapper-info {
			transform: rotateY(-180deg);
		}

		&-data {
			font-size: size(medium);
		}
	}
</style>





// WEBPACK FOOTER //
// src/components/diagnosis/card-total.vue